import * as API from './index'

export default {
    import: params => {
        return API.POSTFORM('/api/Score/Import', params)
    },
    download: params => {
        return API.GETBlog('/api/Score/Export', params)
    }, getList: params => {
        return API.GET('/api/Score/List', params)
    },
    delete: params => {
        return API.DELETE('/api/Score/delete', params)
    },
    deleteMatch: params => {
        return API.DELETE('/api/Score/deleteMatch', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/Score/DeleteBatch', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/score.js